<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">Transactions Refund Report</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getRefundsData({ isPdf: 'N', isExcel: 'N' })"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="refundRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getRefundsData({ isPdf: 'Y', isExcel: 'N' })"
              title="Download as Pdf"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
                style="cursor: pointer"
              />
            </a>
            <a
              target="_blank"
              @click="getRefundsData({ isPdf: 'N', isExcel: 'Y' })"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
                style="cursor: pointer"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        v-if="refundRecords.length > 0"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th colspan="2">{{ $t("transaction") }} {{ $t("No.") }}</th>
            <th colspan="2">{{ $t("Refund") }} {{ $t("Type") }}</th>
            <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }}</th>
            <th>{{ $t("Movie") }}</th>
            <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
            <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
            <th>{{ $tc("screen", 1) }}</th>
            <th>Channel</th>
            <th>
              <p class="mb-0">{{ $tc("seats", 1) }}</p>
            </th>
            <th>Refund Amount</th>
            <th>{{ $tc("refund", 1) }} Date & Time</th>
            <th>Mins After Show Srts.</th>
            <th>{{ $tc("refund", 1) }} {{ $tc("reason", 1) }}</th>
            <th>{{ $t("refunded_by") }}</th>
            <th>{{ $t("authorizedBy") }}</th>
            <th>{{ $tc("payment", 1) }} {{ $tc("mode", 1) }}</th>
            <th>{{ $tc("customer") }}</th>
            <th>{{ $t("mobile") }}</th>
            <th>{{ $t("Remarks") }}</th>
          </thead>
          <tbody
            v-if="refundRecords.length > 0"
            class="sph-report"
            :style="cssVars"
          >
            <tr
              v-for="(transaction, transactionIndex) in refundRecords"
              :key="transactionIndex"
            >
              <td colspan="2" :class="transaction.isSwap > 0 ? 'swap' : ''">
                {{ transaction.sb_booking_code }}
              </td>
               <td colspan="2" :class="transaction.isSwap > 0 ? 'swap' : ''" calss="text-left">
  {{ transaction.isSwap > 0 ? 'Swap Refund' : 'Standard Refund' }}
</td>
              <td>{{ transaction.t_booking_date_time | fulldateparse }}</td>
              <td class="text-left">{{ transaction.film_name }}</td>
              <td class="text-right">{{ transaction.t_show_date | dateparse }}</td>
              <td class="text-right">{{ transaction.t_show_time }}</td>
              <td class="text-left">{{ transaction.screen_name }}</td>
              <td class="text-left">{{ transaction.booking_source }}</td>
              <td class="text-left">{{ transaction.seats }}</td>
              <td class="text-right">
                {{ currFormat(transaction.total_refund_amount | RoundOff) }}
              </td>
              <td class="text-left">
                {{ transaction.t_refund_date_time || "" }}
              </td>
              <td class="text-left">
                {{
                  transaction.time_difference > 0
                    ? transaction.time_difference
                    : "-"
                }}
              </td>
              <td class="text-left">{{ transaction.rr_reason || "-" }}</td>
              <td class="text-left">{{ transaction.refunded_by || "-" }}</td>
              <td class="text-left">
                {{ transaction.refund_approved_by || "-" }}
              </td>
              <td class="text-left">
                {{ transaction.pm_payment_mode || "-" }}
              </td>
              <td class="text-left">
                {{ transaction.customer_name || transaction.guest_name || "-" }}
              </td>
              <td class="text-right">
                {{
                  transaction.customer_mobile || transaction.guest_mobile || "-"
                }}
              </td>
              <td class="text-left">
                {{ transaction.bo_trx_remarks || "-" }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="14">
                <!-- <p class="h6 text-center">{{ $tc("NoRecords") }}</p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      refundRecords: [],
      excelFilePath: "",
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    const { cinema_id } = this.secureStore.get("USINFO");
    this.getCinemaList(cinema_id);
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  computed: {
    cssVars() {
      return {
        "--swap-color": this.swaptextcolor,
      };
    },
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    onChangeDate: function (e, type){
        if(type == 'from'){
            this.toDate = new Date(e);
            this.$forceUpdate();
        }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function (cinema_id) {
      MasterService.GetCinemas({cine_id: cinema_id})
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getRefundsData({ isPdf = "N", isExcel = "N" }) {
      if (isExcel == "N") {
        this.refundRecords = [];
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
      };
      ReportsService.GetTransactionRefunds(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.refundRecords = [...data.Records];
            this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.no_border {
  border: 0px !important;
}

.swap {
  color: #099bf9;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/transactionsRefundReport.vue